// source: proto/cryptography.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var proto = {};

goog.exportSymbol('proto.constants.Argon2Config', null, proto);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.constants.Argon2Config = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.constants.Argon2Config, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.constants.Argon2Config.displayName = 'proto.proto.constants.Argon2Config';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.constants.Argon2Config.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.constants.Argon2Config.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.constants.Argon2Config} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.constants.Argon2Config.toObject = function(includeInstance, msg) {
  var f, obj = {
    separator: jspb.Message.getFieldWithDefault(msg, 1, "$"),
    type: jspb.Message.getFieldWithDefault(msg, 2, "argon2id"),
    version: jspb.Message.getFieldWithDefault(msg, 3, 0),
    memoryInBytes: jspb.Message.getFieldWithDefault(msg, 4, 67108864),
    iterations: jspb.Message.getFieldWithDefault(msg, 5, 3),
    threads: jspb.Message.getFieldWithDefault(msg, 6, 1)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.constants.Argon2Config}
 */
proto.proto.constants.Argon2Config.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.constants.Argon2Config;
  return proto.proto.constants.Argon2Config.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.constants.Argon2Config} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.constants.Argon2Config}
 */
proto.proto.constants.Argon2Config.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeparator(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMemoryInBytes(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIterations(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setThreads(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.constants.Argon2Config.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.constants.Argon2Config.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.constants.Argon2Config} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.constants.Argon2Config.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string separator = 1;
 * @return {string}
 */
proto.proto.constants.Argon2Config.prototype.getSeparator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "$"));
};


/**
 * @param {string} value
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.setSeparator = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.clearSeparator = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.constants.Argon2Config.prototype.hasSeparator = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.proto.constants.Argon2Config.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "argon2id"));
};


/**
 * @param {string} value
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.setType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.clearType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.constants.Argon2Config.prototype.hasType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 version = 3;
 * @return {number}
 */
proto.proto.constants.Argon2Config.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.setVersion = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.clearVersion = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.constants.Argon2Config.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 memory_in_bytes = 4;
 * @return {number}
 */
proto.proto.constants.Argon2Config.prototype.getMemoryInBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 67108864));
};


/**
 * @param {number} value
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.setMemoryInBytes = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.clearMemoryInBytes = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.constants.Argon2Config.prototype.hasMemoryInBytes = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 iterations = 5;
 * @return {number}
 */
proto.proto.constants.Argon2Config.prototype.getIterations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 3));
};


/**
 * @param {number} value
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.setIterations = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.clearIterations = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.constants.Argon2Config.prototype.hasIterations = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 threads = 6;
 * @return {number}
 */
proto.proto.constants.Argon2Config.prototype.getThreads = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 1));
};


/**
 * @param {number} value
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.setThreads = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.constants.Argon2Config} returns this
 */
proto.proto.constants.Argon2Config.prototype.clearThreads = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.constants.Argon2Config.prototype.hasThreads = function() {
  return jspb.Message.getField(this, 6) != null;
};


goog.object.extend(exports, proto);
